export const getSession = () => {
	// @ts-ignore
	const sessionId = new URL(window?.location).searchParams.get('sessionId');
	return (
		window?.['vns']?.store?.telephonySessions?.docs?.[sessionId]
	);
};
